import { PropTypeOptions } from "../budget-review/BudgetReview.constant";

export const PropTypeOptionsMap: Record<string, string> = {
  UNIT: PropTypeOptions.unit,
  CONSOLIDATED: PropTypeOptions.consolidated
};

type BudgetLoanResponse = {
  budgetDocumentInfoList?: Array<{
    budgetStatus?: string;
    selectionMode?: string;
    propertyId?: string | number;
  }>;
};

export const getBudgetReviewPropType = (
  budgetData?: BudgetLoanResponse | null,
  propertyId?: string | number
): string | null => {
  const list = budgetData?.budgetDocumentInfoList;
  if (!list?.length) return null;

  if (propertyId != null && propertyId !== "") {
    const propertyDoc = list.find((doc) => doc.propertyId == propertyId);
    if (propertyDoc?.selectionMode) {
      return PropTypeOptionsMap[propertyDoc.selectionMode] ?? null;
    }
  }

  const activeDoc =
    list.find((doc) => doc.budgetStatus === "ACTIVE") ?? list[0];
  return PropTypeOptionsMap[activeDoc?.selectionMode ?? ""] ?? null;
};
